const linksToEpaper = document.querySelectorAll("a[href*='/OnlinePdf/']");
const template = document.querySelector('#epaper-overlay');

linksToEpaper.forEach(linkToEpaper =>
    {
        linkToEpaper.addEventListener('click', (e) => {
            const overlay = template.content.cloneNode(true);
            const closeButton = overlay.querySelector('.katalog-iframe__close-btn');
            e.preventDefault();
            
            const iframe = overlay.querySelector('.katalog-iframe__iframe');
            iframe.setAttribute('src', linkToEpaper.getAttribute('href')); 

            document.body.appendChild(overlay);
            
            closeButton.addEventListener('click', () => {
                document.body.removeChild(document.querySelector('body > .katalog-iframe__modalbox'));
            });
        });    
    }
);